import { MutationTree } from 'vuex';

import { MetaState } from './meta.state';
// import * as mutationTypes from './meta.mutations.types';

export const mutations: MutationTree<MetaState> = {};



// WEBPACK FOOTER //
// ./src/app/store/meta/meta.mutations.ts